enum ERoute {
  PATH_ROOT = '/:helpCenterId?/:locale',
  PATH_COLLECTION = '/:helpCenterId?/:locale/collections/:id-:slug',
  PATH_ARTICLE = '/:helpCenterId?/:locale/articles/:id-:slug',
}

export default ERoute 